'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _themes = require('@marmalade/themes');
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var _componentThemes$newB = _themes.componentThemes.newBusinessOrderStatus,
  orderStatusStyle = _componentThemes$newB.orderStatusStyle,
  orderStatusTheme = _componentThemes$newB.orderStatusTheme;
var secondaryCopyStyles = function secondaryCopyStyles(_ref) {
  var theme = _ref.theme,
    fontSize = _ref.fontSize;
  return {
    color: orderStatusTheme(theme)[orderStatusStyle('copyColor')],
    fontSize: fontSize,
    fontWeight: 500,
    lineHeight: 1.2
  };
};
exports.default = (0, _glamorous2.default)('p')(secondaryCopyStyles);